import { MailIcon } from "lucide-react";

import { BlueskyIcon } from "@/components/BlueskyIcon";
import { DiscordIcon } from "@/components/DiscordIcon";
import { ButtonAnchor } from "@/components/ui/button";
import { SimpleTooltip, TooltipProvider } from "@/components/ui/tooltip";

export function SocialButtons() {
  return (
    <TooltipProvider>
      <div className="flex gap-0.5">
        <SimpleTooltip message="Follow on BlueSky">
          <ButtonAnchor
            size="lgIcon"
            variant="ghost"
            target="_blank"
            href="https://bsky.app/profile/graze.social"
          >
            <span className="sr-only">Follow on BlueSky</span>
            <BlueskyIcon />
          </ButtonAnchor>
        </SimpleTooltip>

        <SimpleTooltip message="Join the Discord">
          <ButtonAnchor
            size="lgIcon"
            variant="ghost"
            target="_blank"
            href="https://discord.gg/n936Bz7Pug"
            className="[&_svg]:size-6"
          >
            <span className="sr-only">Join the Discord</span>
            <DiscordIcon />
          </ButtonAnchor>
        </SimpleTooltip>

        <SimpleTooltip message="Subscribe to the newsletter">
          <ButtonAnchor
            size="lgIcon"
            variant="ghost"
            target="_blank"
            href="https://graze-newsletter.beehiiv.com/subscribe"
            className="[&_svg]:size-6"
          >
            <span className="sr-only">Subscribe to the newsletter</span>
            <MailIcon />
          </ButtonAnchor>
        </SimpleTooltip>
      </div>
    </TooltipProvider>
  );
}
